import { Outlet } from "react-router-dom";

import { usePageTitle } from "@/hooks/ui/usePageTitle";

export default function AuthLayout() {
	usePageTitle();
	return (
		<div className="flex h-screen w-screen flex-col bg-gray-cool-50">
			<div className="mx-auto flex min-h-0 w-fit flex-1 flex-col items-center justify-center px-10 has-data-fullwidth:w-full has-data-fullwidth:px-0">
				<Outlet />
			</div>
		</div>
	);
}
